import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export const useSetQueryParam = () => {
    const history = useHistory();
    const location = useLocation();

    const setQueryParam = useCallback(
        (key: string, value: string | undefined) => {
            const queryParams = new URLSearchParams(location.search);
            if (value) {
                queryParams.set(key, value);
            } else {
                queryParams.delete(key);
            }
            history.push({
                pathname: location.pathname,
                search: queryParams.toString(),
            });
        },
        [history, location],
    );

    return setQueryParam;
};
